import CallMadeIcon from "@mui/icons-material/CallMade";
import { Button } from "@mui/material";
import { Box } from "@mui/system";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";

type IProps = {
	showDetailsIcon?: boolean;
	navigateDetailsLink?: string;
	navigateBtnName?: string;
	showGoBack?: boolean;
};
const GoBackBtn = ({
	showDetailsIcon,
	navigateDetailsLink,
	navigateBtnName,
	showGoBack,
}: IProps) => {
	const navigate = useNavigate();
	return (
		<Box
			sx={{
				display: "flex",
				justifyContent: "space-between",
				padding: "5px 0 0 5px",
			}}
		>
			{showGoBack && (
				<Button onClick={() => navigate(-1)}>Go back</Button>
			)}

			{showDetailsIcon && (
				<Link to={navigateDetailsLink || ""}>
					<Button>
						{navigateBtnName || "Details"}
						<CallMadeIcon />
					</Button>
				</Link>
			)}
		</Box>
	);
};

export default GoBackBtn;
